import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Select, Textarea, Button, Text, Checkbox, Box, ModalCloseButton } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { showAskForLogin } from "../../actions/ui.actions";

const AskForLogin = () => {
    const uiSelector = useSelector((state) => state.ui);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onClose = () => {
        dispatch(showAskForLogin(false));
    };
    const redirectTologin = () => {
        onClose();
        navigate('/login');
    };
    const redirectTosignup = () => {
        onClose();
        navigate('/signup');
    };
  return (
    <Modal isOpen={uiSelector.askForLogin} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Login</ModalHeader>
         <ModalCloseButton />
        <ModalBody>
            <Text fontSize="md" fontWeight="normal">If you are a registered user, please login to continue.</Text>
            <Text fontSize="lg" fontWeight="bold" mt={5}>If you are not registered, <Link href="/register" className="underline mt-5">Sign Up</Link> </Text>
            
        </ModalBody>
        <ModalFooter className="flex justify-center">
         <Button onClick={redirectTosignup} colorScheme="blue" mt={2} mr={5}>
            Sign Up
          </Button>
          <Button onClick={redirectTologin} colorScheme="blue" mt={2}>
            Login
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AskForLogin;
